import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useDateFormatted(
  data: { date?: string },
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
) {
  const { locale, locales } = useI18n()

  return computed(() => {
    if (!data.date) return

    const dateObj = new Date(data.date)

    // Find the locale in the list of available locales by code
    const localeObj = locales.value.find(site => site.code === locale.value)

    return dateObj.toLocaleDateString(localeObj?.iso || 'de-CH', options)
  })
}
